import uniq from 'lodash-es/uniq';
export const getEstimatedProductionTime = (product) => {
    const variantsProductionTimeFrom = Math.min(...uniq(product.variants.map((item) => item.productionTime.daysFrom)));
    const variantsProductionTimeTo = Math.max(...uniq(product.variants.map((item) => item.productionTime.daysTo)));
    return {
        from: variantsProductionTimeFrom,
        to: variantsProductionTimeTo,
    };
};
